var map = {
	"./components/ComponentAPI.vue": "X3YG",
	"./components/ComponentBase.vue": "+OaP",
	"./components/ExampleComponent.vue": "AEaB",
	"./components/backend/categories/CategoryProduct.vue": "8pGC",
	"./components/backend/categories/CategoryProducts.vue": "5nkS",
	"./components/backend/customers/CustomerEditor.vue": "OuUR",
	"./components/backend/customers/CustomerList.vue": "plUW",
	"./components/common/UserAddress.vue": "ZlYO",
	"./components/frontend/Carts/AddToCart.vue": "Xl8d",
	"./components/frontend/Carts/AddToCartBtn.vue": "67Ty",
	"./components/frontend/Carts/CartList.vue": "irIx",
	"./components/frontend/Carts/CartListBase.vue": "muyi",
	"./components/frontend/Carts/CartQuantity.vue": "iHkR",
	"./components/frontend/Carts/CartQuantitySelector.vue": "2m3j",
	"./components/frontend/Carts/CartRemoveBtn.vue": "YicK",
	"./components/frontend/Carts/NewCartList.vue": "UjZ8",
	"./components/frontend/Carts/ShopCartBtn.vue": "+tZy",
	"./components/frontend/Orders/OrderBase.vue": "Xzd9",
	"./components/frontend/Orders/OrderCartSidebar.vue": "kPDY",
	"./components/frontend/Orders/OrderCartWrapper.vue": "8unK",
	"./components/frontend/Produdts/ProductPrice.vue": "+L9j",
	"./components/frontend/Produdts/ProductSpec.vue": "Uqes",
	"./components/frontend/Profile/UserProfileOrder.vue": "5WEP"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+fAT";